import { RotateCcw } from 'lucide-react';
import { Button } from '@/components/atoms/button';
import { Skeleton } from '@/components/atoms/skeleton';
import type { LoaderRow } from './loaderRows';

// Varied per row so a block of shimmer reads as rows, not as one grey slab.
const FILL = ['w-3/5', 'w-2/5', 'w-1/2'];

export function DataGridLoaderRow({
  row,
  columnWidths,
  onRetry,
  failedLabel,
}: {
  row: LoaderRow;
  /** The displayed columns' widths, so each bar sits under its own header. */
  columnWidths: number[];
  onRetry?: () => void;
  failedLabel: string;
}) {
  if (row.__dataGridLoader === 'error') {
    return (
      <div role="alert" className="flex h-full items-center justify-center gap-3 text-sm text-muted-foreground">
        {failedLabel}
        {onRetry ? (
          <Button variant="outline" size="sm" className="h-7 gap-1.5" onClick={onRetry}>
            <RotateCcw className="size-3.5" aria-hidden />
            Retry
          </Button>
        ) : null}
      </div>
    );
  }
  return (
    <div aria-hidden className="flex h-full items-center">
      {columnWidths.map((width, column) => (
        <div
          key={column}
          style={{ width }}
          className={['shrink-0 px-3', column === 0 ? 'pl-4' : ''].join(' ')}
        >
          <Skeleton className={['h-3.5', FILL[(row.index + column) % FILL.length]].join(' ')} />
        </div>
      ))}
    </div>
  );
}
